import React from 'react';
import { Button, ModalHeader, ModalBody, Card, CardHeader, CardBody, Label  } from 'reactstrap';
import { modalWrapper } from 'components/FDModal';
import { findObj } from 'lib/fp-utility';
import FDConfig from 'lib/config';
import { Field } from 'redux-form'

class CurrencyConversion extends React.Component {
    state = {
        activePanel: ''
    }

    changeCurrency = this.changeCurrency.bind(this)

    componentDidMount(){
		this.props.change('DCCSelected', null)
		this.props.untouch('DCCSelected')
        this.props.change('standingInstruction', false)
    }
    changeCurrency(currencyType){
        this.setState({activePanel: currencyType})
    }

    render() {
        if(!this.props.dccCard){
            return <p>No Option available</p>
        }

        const { t } = this.props
        const exchangeCurrency = findObj(this.props.dccCard.options, FDConfig.exchangeCurrencyLabel, 'type')
        const homeCurrency = findObj(this.props.dccCard.options, FDConfig.homeCurrencyLabel, 'type')
        return (
            <>
                <ModalHeader toggle={this.props.toggleCurrencyConversion}>
                    This is an International Credit Card
                </ModalHeader>
                <ModalBody>
                    <p>Please choose the current payment</p>
                    {
                        exchangeCurrency && 
                        <Card className={this.state.activePanel===FDConfig.exchangeCurrencyLabel ? 'activePanel' : ''}>
                            <CardHeader>
                                <div className="d-flex">
                                    <div className="p-1">
                                        <Field name="DCCSelected" component="input" id="test1" type="radio" value={FDConfig.exchangeCurrencyLabel} onChange={()=>this.changeCurrency(FDConfig.exchangeCurrencyLabel)} />
                                        <Label for="test1">Pay in your home currency</Label>
                                    </div>
                                    <div className="ml-auto p-1 text-20">{t(exchangeCurrency.currencyCode)} {exchangeCurrency.amount}</div>
                                </div>
                            </CardHeader>
                            <CardBody>
                                <p className="text-14">The above payment amount is calculated using an exchange rate of {exchangeCurrency.exchangeRate}(sourced {exchangeCurrency.expirationTime} from {exchangeCurrency.exchangeRateSourceName},
                                plus a standard international margin of {exchangeCurrency.marginRatePercentage}%) This service is provided by ABC and cardholder choice is final.</p>
                                <p className="text-14">I have chosen not to use MasterCard currency conversion and have no recourse against MasterCard concerning the currency conversion or its disclosure</p>
                            </CardBody>
                        </Card>
                    }
                    {
                        homeCurrency &&
                        <Card className={this.state.activePanel===FDConfig.homeCurrencyLabel ? 'activePanel' : ''}>
                            <CardHeader>
                            <div className="d-flex">
                                    <div className="p-1">
                                        <Field name="DCCSelected" component="input" id="test2" type="radio" value={FDConfig.homeCurrencyLabel} onChange={()=>this.changeCurrency(FDConfig.homeCurrencyLabel)}/>
                                        <Label for="test2">Pay in INR</Label>
                                    </div>
                                    <div className="ml-auto p-1 text-20">{t(homeCurrency.currencyCode)} {homeCurrency.amount}</div>
                                </div>
                            </CardHeader>
                            <CardBody>
                                <p className="text-14">Select of this option will result in your card issuer determining a rate of exchange and/ or margin at future point in time</p>
                            </CardBody>
                        </Card>
                    }
                    <Button disabled={!this.state.activePanel} onClick={this.props.submitForm} className="float-right">{t('Continue')}</Button>

                </ModalBody>

            </>
        )
    }
}

export default modalWrapper(true, "CurrencyConversionModal")(CurrencyConversion);